// src/hooks/internal/useNotificationOutlets.tsx
import { useMemo } from "react";
import { NotificationHandlersProvider } from "../../components/notification-item/context.js";
import { useOutletRenderer } from "./useOutletRenderer.js";
import { jsx } from "react/jsx-runtime";
function useNotificationOutlets(props) {
  const { onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, renderNotification: renderItem } = props;
  const handlers = useMemo(
    () => ({ onNotificationClick, onPrimaryActionClick, onSecondaryActionClick }),
    [onNotificationClick, onPrimaryActionClick, onSecondaryActionClick]
  );
  const renderNotificationWithHandlers = useMemo(
    () => renderItem ? (notification) => /* @__PURE__ */ jsx(NotificationHandlersProvider, { value: handlers, children: renderItem(notification) }) : void 0,
    [renderItem, handlers]
  );
  const renderNotification = useOutletRenderer(renderNotificationWithHandlers);
  const renderAvatar = useOutletRenderer(props.renderAvatar);
  const renderSubject = useOutletRenderer(props.renderSubject);
  const renderBody = useOutletRenderer(props.renderBody);
  const renderDefaultActions = useOutletRenderer(props.renderDefaultActions);
  const renderCustomActions = useOutletRenderer(props.renderCustomActions);
  return useMemo(() => {
    if (renderNotification) {
      return { renderNotification };
    }
    return { renderAvatar, renderSubject, renderBody, renderDefaultActions, renderCustomActions };
  }, [renderNotification, renderAvatar, renderSubject, renderBody, renderDefaultActions, renderCustomActions]);
}
export {
  useNotificationOutlets
};
//# sourceMappingURL=useNotificationOutlets.js.map